/**
 * Проходим по уже существующим событиям и вешаемся на них
 *
 * @method
 * @private
 */
function _init() {
  const self = this;
  const eventNames = Object.keys(self._owner.eventsList);

  eventNames.forEach(eventName => {
    self.addListener(eventName);
  });

  return;
}

export default _init;
